module.exports = __webpack_public_path__ + "static/img/z1.b714c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/z1.png
// module id = NGqZ
// module chunks = 0